// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { HashLink as Link } from 'react-router-hash-link';

import styles from '../../styles/PatientSidebarInfo.scss';

type Props = {
  match: Object,
  generalInfo: Object,
  mostRecentHeight: number,
  mostRecentWeight: number,
  testing: Object,
  houseHistory: Object,
  allergies: Object,
  significantHistory: Object,
  wellChildChecks: Object[],
}

class PatientSidebarInfoComponent extends Component<Props> {
  getAge(dobString: string) {
    const dob = moment(dobString);
    const now = moment();
    const years = now.diff(dob, 'years');
    const totalMonths = now.diff(dob, 'months');
    return totalMonths < 36
      ? `${totalMonths} month${totalMonths === 1 ? '' : 's'}`
      : `${years} year${years === 1 ? '' : 's'}`;
  }

  render() {
    const {
      firstName, surname, sex, dob,
    } = this.props.generalInfo;
    const {
      houseHistory, allergies, mostRecentHeight, mostRecentWeight, testing, significantHistory, wellChildChecks,
    } = this.props;
    const {
      hivTests, admissionHivTest0, admissionHivTest6,
    } = testing;

    const allergyString = allergies.map(allergy => allergy.allergen).join(', ');
    const sigHxString = significantHistory.map(sigHx => sigHx.event).join(', ');
    let latestHivTest = hivTests.length > 0 ? hivTests[0] : null;

    // If the latest HIV test is Rapid and there is a PCR test on the same date, prioritize the PCR result.
    // Hard coded to just check the one test before, theoretically should be a for loop to account for multiple
    // Rapid tests and one PCR test all on the same day, but unlikely to happen so hard coding.
    if (hivTests.length > 1 && latestHivTest.date === hivTests[1].date
      && latestHivTest.type === 'Rapid' && hivTests[1].type === 'PCR') {
      [, latestHivTest] = hivTests;
    }

    let hivPositive = hivTests.length > 0 && latestHivTest.positive === 'Positive';
    let latestHivDate = hivTests.length ? latestHivTest.date : '';
    // Handle admissions tests explicitly.
    if (admissionHivTest0 && admissionHivTest0.date
      && !admissionHivTest0.overridden && admissionHivTest0.date > latestHivDate) {
      hivPositive = admissionHivTest0.positive === 'Positive';
      latestHivDate = admissionHivTest0.date;
    }
    if (admissionHivTest6 && admissionHivTest6.date
      && !admissionHivTest6.overridden && admissionHivTest6.date > latestHivDate) {
      hivPositive = admissionHivTest6.positive === 'Positive';
      latestHivDate = testing.admissionHivTest6.date;
    }
    // Handle WCC HIV tests explicitly.
    for (let i = 0; i < wellChildChecks.length; i++) {
      const wcc = wellChildChecks[i];
      if (wcc.vitals.hivTest) {
        hivPositive = wcc.vitals.hivTest === 'Positive';
        latestHivDate = wcc.date;
      }
    }

    return (
      <div className={styles.sidebarInfo}>
        <div className={styles.name}>
          {`${firstName || '--'} ${surname || ''}`}
          {hivPositive && <span className={styles.hivStatus}><span className={styles.hivStatusIcon} /></span>}
        </div>
        <ul className={styles.infoList}>
          <li>{dob && this.getAge(dob)} | {sex || '--'}</li>
          <li>{dob && moment(dob).format()}</li>
          <li>{`${mostRecentHeight} cm, ${mostRecentWeight} kg`}</li>
          <li>{houseHistory[0] && houseHistory[0].house}</li>
          <br />
          <li>{allergyString
            ? <Link to={`${this.props.match.url}/basicInformation#allergies`} smooth>
              <div className={styles.allergyPresent}>
                <strong>Allergies</strong>
                <div>{`${allergyString}`}</div>
              </div>
            </Link>
            : 'Allergies: NKA'}
          </li>
          <br />
          <li>{sigHxString
            ? <Link to={`${this.props.match.url}/basicInformation#significantHistory`} smooth>
              <div className={styles.sigHxPresent}>
                <strong>Significant Hx</strong>
                <div>{`${sigHxString}`}</div>
              </div>
            </Link>
            : 'Significant Hx: None'}
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  generalInfo: state.patient.data.generalInfo,
  mostRecentHeight: state.patient.data.mostRecentHeight,
  mostRecentWeight: state.patient.data.mostRecentWeight,
  testing: state.patient.data.testing,
  houseHistory: state.patient.data.houseHistory,
  allergies: state.patient.data.allergies,
  significantHistory: state.patient.data.significantHistory,
  wellChildChecks: state.patient.data.wellChildChecks,
});

const PatientSidebarInfo = connect(
  mapStateToProps,
)(PatientSidebarInfoComponent);

export default PatientSidebarInfo;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/PatientSidebarInfo.jsx